import { render, staticRenderFns } from "./VAuctionManagerPagination.vue?vue&type=template&id=1069a6a1"
import script from "./VAuctionManagerPagination.vue?vue&type=script&lang=js"
export * from "./VAuctionManagerPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports